import { createRefreshTokenInterceptor } from '@/app/core/interceptors/refreshToken.interceptor';
import { createEchoSocketHeaderInterceptor } from '@/app/core/interceptors/echoSocketHeader.interceptor';

export const initializeApiInterceptors = (apiService, { store, echoService }) => {
    apiService.addInterceptor('response', createRefreshTokenInterceptor(store));

    if (echoService) {
        apiService.addInterceptor('request', {
            successHandler: createEchoSocketHeaderInterceptor(echoService),
        });
    }
};
